import '../styles/ModalCambios.css';

export default function ModalCambios({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-cambios">
        <h3>¡¡Novedades de la versión!!</h3>

        <ul className="lista-cambios">
          <li>CALENDARIO:
            <ul>
              <li className="lista-cambios 2" >Ahora se puede filtrar por "profesional", además de por "clínica"</li>
              <li className="lista-cambios 2">Para esto es necesario introducir el profesional en la cita</li>
            </ul>
          </li>
          <li>ALTA PACIENTE:
            <ul>
              <li className="lista-cambios 2">En el caso de crear un nuevo paciente por el calendario, cuando venga a consulta</li>
              <li className="lista-cambios 2">No dar de alta, acceder a su expediente y en firmar documento, seleccionar ficha de alta.</li>
              <li className="lista-cambios 2">De esta manera se rellenarán sus datos sin duplicar expedientes</li>
            </ul>
          </li>          
          <li>TIEMPO APLICACION:
            <ul>
              <li className="lista-cambios 2">Cuando transcurra el tiempo de cierre de sesión llevará directamente al "Login"</li>
              <li className="lista-cambios 2">Ya no aparecerá la aplicación sin datos o "vacía"</li>
              <li className="lista-cambios 2">Se está mirando a ver como corregirlo y no haya bloqueos de sesión</li>
            </ul>
          </li>
        </ul>

        <h4>Recordatorios</h4>
        <ul className="lista-recordatorios">
          <li>Si se necesita borrar una cita, no hacerlo en el calendar, con hacerlo en la aplicación es suficiente. Puee provocar errores</li>
          <li>Cualquier duda o error, contactar con Raúl.</li>
        </ul>

        <div className="modal-acciones">
          <button onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
